export default __webpack_public_path__ + "static/media/know-job-btn.144f602f.png";